import axios from "axios";

export function createStockTake(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/stocktake/create`, {
        node_uuid: parameters.node_uuid,
        name: parameters.name,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
